import { createAsyncThunk } from "@reduxjs/toolkit";
import { ApiResponse } from "../../../types/APIResponse";
import api from "../../../utils/constants/api";
import { apiEndpoints } from "../../../utils/constants/apiEndpoints";
import { BoxType, BoxTypeInput } from "../../../types/ShippingBoxTypes";
import { DeleteCourier } from "../../../types/CourierTypes";

// Async Thunks
export const fetchShippingBoxType = createAsyncThunk<BoxType[], { status?: number, courierId?: string }, { rejectValue: string }>("shippingBoxType/fetchShippingBoxType", async ({ status, courierId }, { rejectWithValue }) => {
  try {
    const response = await api.get<ApiResponse<BoxType[]>>(apiEndpoints.shippingBox.getAll, {
      params: {
        status,
        courierId
      }
    });
    if (response?.success) {
      return response.data;
    } else {
      throw new Error(response.message || "Failed to fetch shipping box types.");
    }
  } catch (error: any) {
    return rejectWithValue(error.response?.data?.message || error.message);
  }
});

export const createShippingBoxType = createAsyncThunk<BoxType, BoxTypeInput, { rejectValue: string }>("shippingBoxType/createShippingBoxType", async (newBoxTypeData, { rejectWithValue }) => {
  try {
    const response = await api.post<ApiResponse<BoxType>>(apiEndpoints.shippingBox.create, { data: newBoxTypeData });
    if (response?.success) {
      return response.data;
    } else {
      throw new Error(response.message || "Failed to add shipping box type.");
    }
  } catch (error: any) {
    return rejectWithValue(error.message);
  }
});

export const deleteShippingBoxType = createAsyncThunk<DeleteCourier, { id: string }, { rejectValue: string }>("shippingBoxType/deleteShippingBoxType", async ({ id }, { rejectWithValue }) => {
  try {
    const response = await api.delete<ApiResponse<DeleteCourier>>(`${apiEndpoints.shippingBox.delete}/${id}`);
    if (response?.success) {
      return { ...response.data, id };
    } else {
      throw new Error(response.message || "Failed to delete shipping box type.");
    }
  } catch (error: any) {
    return rejectWithValue(error.message);
  }
});

export const updateShippingBoxType = createAsyncThunk<BoxType, BoxTypeInput, { rejectValue: string }>("shippingBoxType/updateShippingBoxType", async (updatedBoxTypeData, { rejectWithValue }) => {
  try {
    const response = await api.put<ApiResponse<BoxType>>(`${apiEndpoints.shippingBox.update}/${updatedBoxTypeData?.id}`, { data: updatedBoxTypeData });
    if (response?.success) {
      return { ...response.data };
    } else {
      throw new Error(response.message || "Failed to update shipping box type.");
    }
  } catch (error: any) {
    return rejectWithValue(error.message);
  }
});
